import { Navigate, Outlet } from "react-router-dom";

import { useCurrentUser } from "../../hooks/useCurrentUser";

export function PlatformAdminGuard() {
  const { user, loading } = useCurrentUser();

  if (loading) {
    return (
      <div className="page">
        <p className="muted">Ładowanie panelu administratora…</p>
      </div>
    );
  }

  if (!user?.is_platform_admin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
